(ns dre.components.tree
  (:require
    [dre.components.icon :refer [svg]]
    [dre.utils.bem :as bem]
    [reagent.core :as r]))


(def component-name :tree)


(defn- traverse-tree
  [root node-fn leaf-fn]
  (letfn [(process-children
            [node children]
            (node-fn node (map process-node children)))
          (process-node
            [node]
            (if-let [children (seq (:children node))]
              (process-children node children)
              (leaf-fn node)))]
    (process-node (with-meta root {:root? true}))))


(defn- item-title
  [item collapsible?]
  (let [collapsed? (r/atom collapsible?)
        not-root? (not (:root? (meta item)))
        {:keys [title href]} item]
    (fn []
      (let [collapsible?' (and not-root? collapsible?)
            collapsed?' (and not-root? @collapsed?)]
        [:span
         {:class [(bem/bem component-name :title
                           [(when collapsible?' :collapsible)
                            (when collapsed?' :collapsed)])]}
         (when collapsible?'
           [:a
            {:class (bem/bem component-name :chevron (when collapsed?' :collapsed))
             :href "#"
             :on-click #(swap! collapsed? not)}
            [svg :common :chevron]])
         (if-not (seq href)
           title
           [:a
            {:class (bem/be component-name :link)
             :href href
             :title title}
            title])]))))


(defn- item-node
  [item children]
  (when (seq (:title item))
    [:ul
     {:class (bem/be component-name :node)}
     [item-title item true]
     (->> children
          (map-indexed (fn [idx child]
                         (with-meta child {:key idx}))))]))


(defn- item-leaf
  [item]
  (when (seq (:title item))
    [:li
     {:class (bem/be component-name :leaf)}
     [item-title item false]]))


(defn tree
  "Construct a collapsible-tree widget out of an arbitrarily nested structure
  of nodes. Each node needs to be a hash-map with at least :title key and
  optional :href and :children keys, :children to be a sequence of nodes."
  [t]
  [:div
   {:class component-name}
   (traverse-tree t item-node item-leaf)])
